import { useEffect } from 'react';

const SEO = ({ title, description, canonical, articleData, faqData }) => {
  useEffect(() => {
    // 1. Update Title and Meta Tags
    if (title) document.title = `${title} | Nouria`;
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink && canonical) {
      canonicalLink.setAttribute('href', `https://nouria.fit${canonical}`);
    }

    // 2. Prepare JSON-LD Scripts
    const schemas = [];

    // Base Product Schema (Always present)
    schemas.push({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Nouria AI Diet Coach",
      "description": description || "AI-powered gut and metabolic health tracker.",
      "brand": { "@type": "Brand", "name": "Nouria" },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/PreOrder"
      }
    });

    // FAQ Schema
    if (faqData) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqData.map(item => ({
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": { "@type": "Answer", "text": item.answer }
        }))
      });
    }

    // Article Schema for Blogs
    if (articleData) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": articleData.title,
        "image": [`https://nouria.fit${articleData.image}`],
        "datePublished": articleData.date,
        "author": { "@type": "Organization", "name": "Nouria Team" },
        "publisher": {
          "@type": "Organization",
          "name": "Nouria",
          "logo": { "@type": "ImageObject", "url": "https://nouria.fit/logo192.png" }
        },
        "description": articleData.summary
      });
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [title, description, canonical, articleData, faqData]);

  return null;
};

export default SEO;
